import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementAdvisorCompany } from '../models/engagement-advisor-company.model';

export const GetEngagementAdvisorCompanies = createAsyncThunk(
    'timelines/getEngagementAdvisorCompanies',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.get(
            '/api/marketplace/engagements/advisor-companies'
        );

        if (response.status !== 200) {
            createNotification(
                'Could not fetch engagement advisor companies at the moment.',
                'error'
            );
            throw new Error('Failed to fetch engagement advisor companies');
        }

        return {
            advisorCompanies: response.data as EngagementAdvisorCompany[],
        };
    }
);
